import { KeyboardShortcut } from '@databases/react';

export const isApple = !!navigator.platform.match(/iphone|ipad|ipod|mac/i);

export const UNDO_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: [isApple ? 'metaKey' : 'ctrlKey'],
    code: 'KeyZ',
  },
];

export const REDO_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: [isApple ? 'metaKey' : 'ctrlKey', 'shiftKey'],
    code: 'KeyZ',
  },
];

export const DUPLICATE_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: ['ctrlKey'],
    code: 'KeyD',
  },
  {
    modifiers: ['metaKey'],
    code: 'KeyD',
  },
];

export const ADD_ABOVE_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: ['ctrlKey', 'altKey'],
    code: 'ArrowUp',
  },
  {
    modifiers: ['metaKey', 'altKey'],
    code: 'ArrowUp',
  },
];

export const ADD_BELOW_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: ['ctrlKey', 'altKey'],
    code: 'ArrowDown',
  },
  {
    modifiers: ['metaKey', 'altKey'],
    code: 'ArrowDown',
  },
];

export const MOVE_UP_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: ['ctrlKey', 'altKey', 'shiftKey'],
    code: 'ArrowUp',
  },
  {
    modifiers: ['metaKey', 'altKey', 'shiftKey'],
    code: 'ArrowUp',
  },
];

export const MOVE_DOWN_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: ['ctrlKey', 'altKey', 'shiftKey'],
    code: 'ArrowDown',
  },
  {
    modifiers: ['metaKey', 'altKey', 'shiftKey'],
    code: 'ArrowDown',
  },
];

export const ADD_LEFT_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: ['ctrlKey', 'altKey'],
    code: 'ArrowLeft',
  },
  {
    modifiers: ['metaKey', 'altKey'],
    code: 'ArrowLeft',
  },
];

export const ADD_RIGHT_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: ['ctrlKey', 'altKey'],
    code: 'ArrowRight',
  },
  {
    modifiers: ['metaKey', 'altKey'],
    code: 'ArrowRight',
  },
];

export const MOVE_LEFT_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: ['ctrlKey', 'altKey', 'shiftKey'],
    code: 'ArrowLeft',
  },
  {
    modifiers: ['metaKey', 'altKey', 'shiftKey'],
    code: 'ArrowLeft',
  },
];

export const MOVE_RIGHT_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: ['ctrlKey', 'altKey', 'shiftKey'],
    code: 'ArrowRight',
  },
  {
    modifiers: ['metaKey', 'altKey', 'shiftKey'],
    code: 'ArrowRight',
  },
];

export const CLEAR_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: [],
    code: 'Backspace',
  },
];

export const DELETE_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: ['ctrlKey'],
    code: 'Backspace',
  },
  {
    modifiers: ['metaKey'],
    code: 'Backspace',
  },
];

export const OPEN_COMMENTS: KeyboardShortcut[] = [
  {
    modifiers: ['metaKey', 'altKey', 'shiftKey'],
    code: 'C',
  },
  {
    modifiers: ['ctrlKey', 'altKey', 'shiftKey'],
    code: 'C',
  },
];

export const SUBMIT_SHORTCUT: KeyboardShortcut[] = [
  {
    modifiers: [],
    code: 'Enter',
  },
];

export const CLOSE_SHORTCUT: KeyboardShortcut[] = [{ modifiers: [], code: 'Escape' }];
